import React from 'react';
import ReactPlayer from 'react-player';
import { Typography, Box } from "@mui/material";

const VideoPlayer = ({ url, message, ...props }) => {
    return (
        <Box
            sx={{
                background: 'gray',
                borderRadius: '5px',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
            {...props}
        >
            {message && !url ? (
                <Typography color="white">{message}</Typography>
            ) : (
                <ReactPlayer
                    url={url}
                    className='react-player'
                    playing={!!url}
                    width='100%'
                    height='100%'
                    controls={true}
                />
            )}
        </Box>
    );
};

export default VideoPlayer;